var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { useLoaderData } from 'react-router';
import { useAtomValue } from 'jotai';
import { Translate } from "../../../../../../I18N";
import { availableLanguages } from "../../../../../../../shared/language";
import { templatesAtom } from "../../../../../atoms";




import { DisplayPill } from "../DisplayPills";

const ViewParagraph = ({ paragraphData }) => {var _sourceEntity$documen;
  const { sourceEntity } = useLoaderData();
  const templates = useAtomValue(templatesAtom);
  const paragraphTemplate = templates.find((template) => template._id === paragraphData.template);
  const language = availableLanguages.find((lang) => lang.key === paragraphData.language);

  const sourceDocument =
  (sourceEntity === null || sourceEntity === void 0 ? void 0 : (_sourceEntity$documen = sourceEntity.documents) === null || _sourceEntity$documen === void 0 ? void 0 : _sourceEntity$documen.find((document) => document.language === (language === null || language === void 0 ? void 0 : language.ISO639_3))) ||
  (sourceEntity === null || sourceEntity === void 0 ? void 0 : sourceEntity.documents) && sourceEntity.documents[0];

  return (/*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "rounded-md bg-gray-50 text-sm font-bold flex gap-2 justify-between p-3" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, paragraphData.title), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(DisplayPill, { color: paragraphTemplate === null || paragraphTemplate === void 0 ? void 0 : paragraphTemplate.color }, void 0, /*#__PURE__*/
    _jsx(Translate, { context: paragraphTemplate === null || paragraphTemplate === void 0 ? void 0 : paragraphTemplate._id }, void 0, paragraphTemplate === null || paragraphTemplate === void 0 ? void 0 : paragraphTemplate.name)
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "rounded-md leading-tight text-sm font-bold border border-gray-100 p-3" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Language"), ": ", language === null || language === void 0 ? void 0 : language.localized_label
    ), /*#__PURE__*/
    _jsx("div", { className: "rounded-md leading-tight text-sm font-bold border border-gray-100 p-3" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Document"), ": ", sourceDocument === null || sourceDocument === void 0 ? void 0 : sourceDocument.originalname
    ), /*#__PURE__*/
    _jsx("div", { className: "rounded-md leading-tight text-sm font-bold border border-gray-100 p-3" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Paragraph"), ": ", paragraphData.paragraphNumber
    ), /*#__PURE__*/
    _jsx("div", { className: "flex-grow rounded-md border border-gray-100 flex flex-col gap-2 p-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "leading-tight text-sm font-bold" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Text")
    ), /*#__PURE__*/
    _jsx("div", { className: "text-sm text-gray-900 leading-[21px]" }, void 0, paragraphData.paragraphText)
    )
    ));

};

export { ViewParagraph };